export const LOCAL_STORAGE_KEYS = {
  DISMISSED_UPDATES: 'dismissedUpdates',
  DISMISSED_PLATFORM_BANNERS: 'dismissedPlatformBanners',
  WIDGET_BUILDER: 'widgetBubble_',
  DRAFT_MESSAGES: 'draftMessages',
  COLOR_SCHEME: 'color_scheme',
  COLOR_PALETTE: 'color_palette',
  // 一次性全员切雅黑的迁移标记（见 themeHelper#forceDefaultPaletteOnce）
  COLOR_PALETTE_FORCED: 'color_palette_forced_v1',
  DISMISSED_LABEL_SUGGESTIONS: 'labelSuggestionsDismissed',
  MESSAGE_REPLY_TO: 'messageReplyTo',
  RECENT_SEARCHES: 'recentSearches',
  SIDEBAR_MINIMIZED_SECTIONS: 'sidebarMinimizedSections',
  CRM_TEAM_DASHBOARD_TEAM: 'crmTeamDashboardTeam',
};
